/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import IntroSection from './components/introSection';
import InvestmentRisksSection from './components/investmentRisksSection';
import OtherInvestingRelatedTermsSection from './components/otherInvestingRelatedTermsSection';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      mainAttributes={{
        itemScope: true,
        itemType: 'https://schema.org/FAQPage',
      }}
      disableDisclaimerTopBorder={false}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Commentary Disclosure',
          linkUrl: '/commentary-disclosure/',
          linkAriaLabel: 'Northwestern Mutual Commentary Disclosure',
        },
      ]}
      customDisclaimers={[
        <>
          Market performance can&#39;t be predicted, so nothing in our commentaries is ever meant to provide any kind of guarantee of future results. To learn more about how investing fits into your financial plan, visit <a href='/financial-planning/'>NM.com&#47;financial&#45;planning&#47;</a>.
        </>,
      ]}>

      {/* PAGE CONTENT */}
      <IntroSection />

      {/* INVESTMENT RISKS SECTION */}
      <InvestmentRisksSection />

      {/* OTHER INVESTING RELATED TERMS SECTION  */}
      <OtherInvestingRelatedTermsSection />

    </Page>
  );
};
